import { Placement } from '@popperjs/core';
import classNames from 'classnames';
import React, { MouseEvent, useCallback, useRef, useState, VFC } from 'react';
import { EventBus } from 'src/common/EventBus';
import { IconButton } from 'src/common/icon-button';
import { TooltipComponent } from 'src/common/tooltip/component';
import { DotMenuStrongIcon, EditStrongIcon } from 'src/monet/icons';
import { DashboardSettingsManageWorkspacesOptions } from './options';

interface DashboardSettingsManageWorkspacesActionsProps {
  isProtectedWorkspace: boolean;
  rowIndex: number;
}

export const DashboardSettingsManageWorkspacesActions: VFC<DashboardSettingsManageWorkspacesActionsProps> = ({
  rowIndex,
  isProtectedWorkspace,
}) => {
  const [keepMenuOpen, setKeepMenuOpen] = useState(false);
  const menuPlacementRef = useRef<Placement>();

  const onMenuOpen = (placement?: Placement) => {
    menuPlacementRef.current = placement;
    setKeepMenuOpen(true);
  };

  const onMenuClose = () => {
    setKeepMenuOpen(false);
  };

  const stopPropagation = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
  };

  const onEditIconClicked = useCallback(() => {
    EventBus.emit('dashboard-settings:workspace-edit', rowIndex);
  }, [rowIndex]);

  const onDeleteWorkspaceConfirmed = useCallback(() => {
    EventBus.emit('dashboard-settings:workspace-delete', rowIndex);
  }, [rowIndex]);

  return (
    <div
      className={classNames(
        'flex transition group-hover:opacity-100 grow-0 items-center space-x-sm justify-end',
        keepMenuOpen ? 'opacity-100' : 'opacity-0'
      )}
      onClick={stopPropagation}
    >
      <div className='flex items-center space-x-sm'>
        <TooltipComponent placement='top' tooltipContent='Edit Workspace'>
          <IconButton onClick={onEditIconClicked}>
            <EditStrongIcon />
          </IconButton>
        </TooltipComponent>
        {!isProtectedWorkspace && (
          <DashboardSettingsManageWorkspacesOptions
            onMenuOpen={onMenuOpen}
            onMenuClose={onMenuClose}
            onDeleteWorkspaceConfirm={onDeleteWorkspaceConfirmed}
            renderMenuOrigin={(onClick) => (
              <IconButton onClick={onClick}>
                <DotMenuStrongIcon />
              </IconButton>
            )}
          />
        )}
      </div>
    </div>
  );
};
